/**
 * 插件统一导出
 */

import type { App } from 'vue'
import AutoTestIdPlugin, { type AutoTestIdOptions } from './auto-testid'

/**
 * 安装所有插件
 * @param app Vue应用实例
 * @param options 插件配置
 */
export function setupPlugins(app: App, options: {
  autoTestId?: AutoTestIdOptions
} = {}) {
  // 安装自动测试ID插件
  app.use(AutoTestIdPlugin, options.autoTestId)
}

// 导出单个插件
export { AutoTestIdPlugin }
export type { AutoTestIdOptions }

